import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabName from '../../form-fields/tab-name/tab-name';
class EditViewClientTabName extends Component {
  render() {
    return (
      <div>
        <FormFieldsTabName {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewClientTabName.propTypes = {
  locked: PropTypes.bool,
}
EditViewClientTabName = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabName);
export default EditViewClientTabName;